import { toast } from 'react-toastify';
import PostHouseholdsToCalculator from '../../../services/adapters/householdsToCalculator';
import { defaultToastOptions } from '../../../components/app-layout/toastStore';
import { SelectedFilters } from '../../../types/filters.type';

// Sends the households matching the filters to the calculator, with progress shown in toasts
export default async function sendToCalculator(filters: SelectedFilters): Promise<void> {
  await toast.promise(
    new PostHouseholdsToCalculator().adaptResponse({ data: filters }),
    {
      pending: 'Sending cases to the calculator...',
      success: 'Case(s) successfully sent to the calculator',
      error: 'An error occurred, please try again, or contact helpdesk@policyinpractice.co.uk',
    },
    defaultToastOptions,
  );
}
